"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DurationExample = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.DurationExample = styled_components_1.default.p `
	font-weight: bold;
	text-align: center;
`;
